<template>
  <div class="register-container">
    <el-card class="register-card">
      <div class="logo-wrapper">
        <img src="/logo5-green.png" alt="لوگو" class="logo" />
        <h3>ثبت نام</h3>
      </div>
      <form @submit.prevent="submitRegistration">
        <div v-if="step === 1">
          <el-form :model="formStep1" label-position="top">
            <el-form-item label="نام و نام خانوادگی">
              <el-input
                v-model="formStep1.name"
                placeholder="نام خود را وارد کنید"
              />
            </el-form-item>

            <el-form-item label="شماره موبایل">
              <el-input
                v-model="formStep1.mobile"
                @input="(val) => (formStep1.mobile = val.replace(/\D/g, ''))"
                placeholder="شماره موبایل"
                @keypress="numericKeypress"
              />
            </el-form-item>

            <el-form-item label="کد ملی">
              <el-input
                v-model="formStep1.national_code"
                @keyup.enter="validateStep1"
                @input="
                  (val) => (formStep1.national_code = val.replace(/\D/g, ''))
                "
                @keypress="numericKeypress"
                placeholder="کد ملی"
              />
            </el-form-item>

            <el-button type="primary" @click="validateStep1" class="w-full"
              >مرحله بعد</el-button
            >
          </el-form>
        </div>

        <div v-if="step === 2">
          <el-form
            :model="formStep2"
            label-position="top"
            ref="formRef"
            autocomplete="off"
          >
            <el-form-item label="منطقه">
              <el-select
                v-model="formStep2.regionID"
                placeholder="منطقه را انتخاب کنید"
                @change="onRegionChange"
              >
                <el-option
                  v-for="item in regions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="ناحیه">
              <el-select
                v-model="formStep2.areaID"
                placeholder="ناحیه را انتخاب کنید"
              >
                <el-option
                  v-for="item in areas"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <input
              type="text"
              name="fake-code"
              autocomplete="off"
              style="display: none"
            />

            <el-form-item label="کد اعتبار سنجی">
              <el-input
                :key="`code-${inputKey}`"
                :name="`code-${inputKey}`"
                v-model="formStep2.code"
                @input="(val) => (formStep2.code = val.replace(/\D/g, ''))"
                placeholder="کد اعتبار سنجی"
                autocomplete="new-key"
                @keypress="numericKeypress"
              />
              <div @click="validateStep1" class="timer-class">
                {{
                  timeLeft != 0
                    ? `ارسال مجدد کد تا  (${timeLeft}) ثانیه`
                    : "ارسال مجدد کد اعتبار سنجی"
                }}
              </div>
            </el-form-item>

            <el-form-item label="رمز عبور">
              <el-input
                :key="`pass-${inputKey}`"
                :name="`pass-${inputKey}`"
                v-model="formStep2.password"
                type="password"
                show-password
                autocomplete="new-password"
                placeholder="رمز عبور"
                @keypress="passwordKeypress"
              />
            </el-form-item>

            <el-form-item label="تکرار رمز عبور">
              <el-input
                v-model="formStep2.passwordConfirmation"
                type="password"
                show-password
                @keypress="passwordKeypress"
                placeholder="تکرار رمز عبور"
              />
            </el-form-item>
          </el-form>
          <div class="button-group">
            <el-button @click="step = 1">بازگشت به مرحله قبل</el-button>
            <el-button
              type="primary"
              native-type="submit"
              :loading="isSubmitting"
              >ثبت نام</el-button
            >
          </div>
        </div>
      </form>
    </el-card>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { showToast } from "@/utils/toastHelper";
import {
  passwordKeypress,
  validatePassword,
  numericKeypress,
  validateNationalCode,
} from "@/utils/validateInput";

import {
  validateUser,
  getRegions,
  getArea,
  registerUser,
} from "@/services/auth"; // فرض بر این است که این API ها را دارید

const timeLeft = ref(90);
let timerInterval = null;
const isSubmitting = ref(false);
const step = ref(1);
const inputKey = ref(null);
onMounted(async () => {
  inputKey.value = ref(Date.now());
  regions.value = await getRegions();
});
// داده های مرحله اول
const formStep1 = reactive({
  name: "",
  mobile: "",
  national_code: "",
  server_id: "",
});

// داده های مرحله دوم
const formStep2 = reactive({
  regionID: null,
  areaID: null,
  code: "",
  password: "",
  passwordConfirmation: "",
});

// لیست مناطق و نواحی
const regions = ref([]);
const areas = ref([]);

// هنگام تغییر منطقه، نواحی جدید را بارگذاری کن
const onRegionChange = async (regionId) => {
  formStep2.regionID = regionId; // پاک کردن انتخاب قبلی ناحیه
  formStep2.areaID = null;
  try {
    areas.value = await getArea(regionId);
  } catch (err) {
    showToast("خطا در بارگذاری نواحی", "error");
  }
};
function startTimer() {
  if (timerInterval) clearInterval(timerInterval);
  // اینجا می‌تونی API ارسال کد رو صدا بزنی

  timeLeft.value = 90;

  timerInterval = setInterval(() => {
    timeLeft.value--;
    if (timeLeft.value <= 0) {
      clearInterval(timerInterval);
    }
  }, 1000);
}

// اعتبارسنجی مرحله اول و ارسال به سرور برای بررسی یکتا بودن
const validateStep1 = async () => {
  let message = "";
  let valid = true;
  if (step.value == 2 && timeLeft.value != 0) return;

  if (!formStep1.name.trim()) {
    message = "نام و نام خانوادگی را وارد کنید<br>";
    valid = false;
  } else {
    if (formStep1.name.trim().indexOf(" ") <= 1) {
      //space between name and family
      valid = false;
      message = "بین نام و نام خانوادگی باید فاصله باشد<br>";
    }
  }
  if (formStep1.mobile.length !== 11) {
    message += "شماره موبایل باید 11 رقم باشد<br>";
    valid = false;
  }
  if (formStep1.national_code.length !== 10) {
    message += "کد ملی باید 10 رقم باشد<br>";
    valid = false;
  } else {
    if (!validateNationalCode(formStep1.national_code)) {
      valid = false;
      message += "کد ملی نامعتبر است";
    }
  }

  if (!valid) {
    showToast(message, "error");
    return;
  }
  try {
    formStep1.server_id = await validateUser({
      mobile: formStep1.mobile,
      national_code: formStep1.national_code,
    });
    startTimer();
    step.value = 2;
  } catch (error) {
    if (error.response?.data?.errors) {
      error.response.data.errors.forEach((msg) => {
        showToast(msg, "error");
      });
    } else {
      showToast("خطا در بررسی اطلاعات کاربر", "error");
    }
  }
};
function validateRegister() {
  let message = "";
  let valid = true;

  if (!formStep2.regionID) {
    message += "منطقه را انتخاب کنید<br>";
    valid = false;
  }
  if (!formStep2.areaID) {
    message += "ناحیه را انتخاب کنید<br>";
    valid = false;
  }
  if (!formStep2.code) {
    message += "کد اعتبار سنجی را وارد کنید<br>";
    valid = false;
  }
  if (!validatePassword(formStep2.password)) valid = false;

  if (formStep2.password !== formStep2.passwordConfirmation) {
    message += "تکرار رمز عبور با رمز عبور مطابقت ندارد<br>";
    valid = false;
  }

  if (!valid) {
    if (message != "") showToast(message.trim(), "error");
    return valid;
  }
  return valid;
}
// ارسال نهایی ثبت نام
const submitRegistration = async () => {
  if (!validateRegister()) return;
  isSubmitting.value = true;
  try {
    await registerUser({
      ...formStep1,
      area_id: formStep2.areaID,
      code: formStep2.code,
      password: formStep2.password,
      password_confirmation: formStep2.passwordConfirmation,
    });
    showToast(
      "ثبت نام با موفقیت انجام پس از تایید کارشناس مجوز ورود به سایت را خواهید گرفت.",
      "success"
    );
    setTimeout(() => {
      window.location.href = "/login";
    }, 5000);
    // مثلا به صفحه ورود منتقل شود یا ریست فرم و مرحله 1
  } catch (error) {
    isSubmitting.value = false;
    if (error.response?.data?.message) {
      showToast(error.response.data.message, "error");
    } else {
      showToast("خطا در ثبت نام", "error");
    }
  }
};
</script>

<style>
.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.register-card {
  width: 450px;
  padding: 2rem;
  background: #f9fbfd;
  border-radius: 20px;
}

.logo-wrapper {
  text-align: center;
  margin-bottom: 1.5rem;
}

.logo {
   width: 200px;
  height: 100px;
  margin-bottom: 0.5rem;
}

.button-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
}

.button-group .el-button {
  flex: 1 1 110px;
  max-width: 200px;
}
.el-select__placeholder.is-transparent,
.el-select__placeholder {
  text-align: right !important;
}
.timer-class {
  color: darkred;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
</style>
